import { ticketList } from './mock';

export default () => {
  return {
    ticketList,
  };
};
